
export const environment = {
  production: false,
  apiUrl: "https://api.re-flow.dk",
  aad_config: {
    api_id: 'undefined',
    client_id: 'undefined',
    tenant_id: 'undefined'
  }
};
